import React, { useContext, useMemo } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { TOTP_STEPS_COUNT } from '../constants';
import { SecurityTOTPContext } from '../../../../contexts/SecurityTOTP/context';

export const SecurityTOTPBodyLayout = ({
  children,
  withBack,
  onPrevClick,
  title,
  className,
  renderButtons,
}) => {
  const { t: translate } = useTranslation();

  const { state, openTOTPStepsPopup } = useContext(SecurityTOTPContext);

  const currentScreen = state?.currentScreen;
  const TOTPSteps = state?.TOTPSteps;

  const showStepsLabel = useMemo(() => {
    if (currentScreen && TOTPSteps) {
      const totpStepskeys = Object.keys(TOTPSteps);
      return totpStepskeys.includes(currentScreen);
    }
    return false;
  }, [currentScreen, TOTPSteps]);

  return (
    <div
      className={`d-flex flex-column main-layout-body-container letter-spacing-sm ${className} totp-body-container`}>
      {(withBack || showStepsLabel) && (
        <div className="d-flex flex-row justify-content-between align-items-center">
          {withBack && (
            <div
              className="cursor-pointer text-hover"
              onClick={onPrevClick}
              onKeyDown={onPrevClick}
              role="presentation">
              <i className="icon icon-arrow_back-navigation text-f5 me-2" aria-label="Back" />
            </div>
          )}
          <div className="d-flex flex-row align-items-center justify-content-end w-100">
            {showStepsLabel && (
              <div
                onClick={openTOTPStepsPopup}
                onKeyDown={openTOTPStepsPopup}
                role="button"
                tabIndex={-1}>
                <p className="d-md-none text-primary text-f5 text-bold">
                  {translate('totp_steps_label')
                    .replace('__CURRENTSTEP__', TOTPSteps[currentScreen].step)
                    .replace('__TOTAL__', TOTP_STEPS_COUNT)}
                </p>
              </div>
            )}
          </div>
        </div>
      )}
      <div className="d-flex flex-row justify-content-between align-items-center mt-3 mt-md-4 mb-md-3">
        {/* mobile */}
        <p className="d-block d-md-none text-dark text-bold text-f4">{title}</p>

        {/* browser */}
        <p className="d-none d-md-block text-dark text-bold text-f3">{title}</p>
      </div>
      {children}
      {renderButtons && (
        <div className="d-flex flex-row justify-content-center w-100 totp-body-btn-container">
          <div
            className="totp-body-btn-container-inner letter-spacing-sm"
            style={{
              bottom: '4%',
            }}>
            {renderButtons()}
          </div>
        </div>
      )}
    </div>
  );
};

export default SecurityTOTPBodyLayout;

SecurityTOTPBodyLayout.propTypes = {
  children: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  withBack: PropTypes.bool,
  title: PropTypes.string,
  className: PropTypes.string,
  onPrevClick: PropTypes.func,
  renderButtons: PropTypes.func,
};

SecurityTOTPBodyLayout.defaultProps = {
  withBack: false,
  title: null,
  children: null,
  className: '',
  onPrevClick: null,
  renderButtons: null,
};
